import { JobPositionGeneralInfo as JobPositionGeneralInfoCard, UserTypeEnum } from "@cpj-ai/panel-npm-package";
import { AdminJobPositionNode } from "@graphql/generated";
import { Spinner, useDisclosure } from "@heroui/react";
import { ChangeStatusModal } from "./ChangeStatusModal";

interface JobPositionGeneralInfoProps {
  jobPosition: AdminJobPositionNode;
  refetch: () => void;
  loading: boolean;
}

const JobPositionGeneralInfo = ({ jobPosition, refetch, loading }: JobPositionGeneralInfoProps) => {
  const {
    isOpen: isStatusModalOpen,
    onOpen: onStatusModalOpen,
    onClose: onStatusModalClose,
    onOpenChange: onStatusModalOpenChange,
  } = useDisclosure();

  // const { isOpen: isConfirmModalOpen, onClose: onConfirmModalClose } = useDisclosure();

  // const navigateToEdit = () => {
  //   if (!id) return;
  //   navigate(routes.jobPositions.edit?.replace(":id", id));
  // };

  if (loading) return <Spinner size="sm" className="my-5" />;

  return (
    <>
      <ChangeStatusModal
        status={jobPosition?.status}
        isOpen={isStatusModalOpen}
        onClose={onStatusModalClose}
        onOpenChange={onStatusModalOpenChange}
        refreshData={() => {
          refetch();
        }}
        jobPosition={jobPosition}
      />

      {/* <ConfirmModal
        isOpen={isConfirmModalOpen}
        onClose={onConfirmModalClose}
        messageClassName="text-center text-base"
        message="Are you sure you want to edit job post?"
        confirmLabel="Yes"
        onConfirm={navigateToEdit}
      /> */}

      <JobPositionGeneralInfoCard
        onClickStatus={onStatusModalOpen}
        jobPosition={jobPosition}
        userType={UserTypeEnum.ADMIN}
        // onClickEdit={navigateToEdit}
      />
    </>
  );
};

export default JobPositionGeneralInfo;
